const FREE_TEXT_MIN_LENGTH = 40;
const RULES = [
  ["email", /^[^\s@]+@[^\s@]+\.[^\s@]+$/],
  ["uuid", /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i],
  ["object-id", /^[0-9a-f]{24}$/i],
  ["ip-address", /^(\d{1,3}(\.\d{1,3}){3}|[0-9a-f:]*:[0-9a-f:]+)$/i],
  // Dot-separated labels ending in an alphabetic TLD, e.g. host.example.com.
  ["hostname", /^[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}$/i]
];
const detectPiiSuspect = (value) => {
  if (typeof value !== "string") return null;
  if (value.includes("/")) return null;
  const match = RULES.find(([, pattern]) => pattern.test(value));
  if (match) return match[0];
  if (value.length >= FREE_TEXT_MIN_LENGTH && value.includes(" ")) return "free-text";
  return null;
};
export default detectPiiSuspect;
